/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { V1EmailDestinations } from '../models/V1EmailDestinations';
import { V1TemplateConfigType } from '../models/V1TemplateConfigType';
import { HttpFile } from '../http/http';

export class V1EmailTemplateConfig {
    'id'?: string;
    'routeId'?: string;
    'type'?: V1TemplateConfigType;
    'templateName'?: string;
    'subject'?: string;
    'emailDestinations'?: V1EmailDestinations;
    'fields'?: Array<string>;
    'recipientFields'?: Array<string>;
    'conditional'?: Array<string>;
    'attachmentFields'?: Array<string>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "routeId",
            "baseName": "route_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "V1TemplateConfigType",
            "format": ""
        },
        {
            "name": "templateName",
            "baseName": "template_name",
            "type": "string",
            "format": ""
        },
        {
            "name": "subject",
            "baseName": "subject",
            "type": "string",
            "format": ""
        },
        {
            "name": "emailDestinations",
            "baseName": "email_destinations",
            "type": "V1EmailDestinations",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "recipientFields",
            "baseName": "recipient_fields",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "conditional",
            "baseName": "conditional",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "attachmentFields",
            "baseName": "attachment_fields",
            "type": "Array<string>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1EmailTemplateConfig.attributeTypeMap;
    }

    public constructor() {
    }
}

